<template>
  <div class="flex w-1/2 h-full items-center justify-center py-8">
    <div class="items-center justify-center w-full h-full flex-wrap py-8">
      <div class="w-full items-center justify-center py-8">
        <img src="@/assets/images/hireful/newlogo.svg" loading="lazy" alt="hireful logo" class="hireful-logo-container" />
      </div>
      <div class="flex w-full items-center justify-start text-hireful hireful-font-semibold hireful-title py-4">
        {{pageTitle}}
      </div>
      <div v-if="!showReset">
        <div class="flex flex-wrap w-full items-center justify-start py-4">
          <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
            Please enter your email address in the field below
          </div>
          <div class="flex w-full">
            <text-field v-model="user.email" @enter="forgotPassword()" />
          </div>
        </div>
        <div class="flex flex-wrap w-full item-center justify-center" v-if="showNotification">
          <hireful-notification :msg="notificationMessage"></hireful-notification>
        </div>
        <div class="flex w-full items-center justify-center py-4">
          <loader v-if="loading" />
          <div class="flex flex-wrap w-full items-center justify-center" v-else>
            <button class="bg-hireful text-white w-full hireful-font-semibold h-12 rounded-lg" @click="forgotPassword()" >
              Send code
            </button>
            <router-link class="flex w-full items-center justify-center py-4" :to="{ name: 'Login' }">
              <span class="hireful-font-semibold text-gray-400">
                Go back
              </span>
            </router-link>
          </div>
        </div>
        <div class="flex w-full items-center justify-center text-left hireful-font-domus text-gray-400 py-4">
          If an account on our system matches your email address we will send you a code which will let you change your password.
        </div>
        <div class="flex flex-wrap w-full items-center justify-center text-left hireful-font-domus text-gray-400 py-4">
          If you do not receive a code and you are certain you have an account please get in touch with <a class="contents text-hireful-link" href="mailto:support@hireful.co.uk">support@hireful.co.uk</a>
        </div>
      </div>
      <div class="flex flex-wrap w-full items-center justify-center" v-else>
        <div class="flex flex-wrap w-full items-center justify-center" v-if="resetSuccess">
          <div class="flex w-full items-center justify-start text-left hireful-font-domus text-gray-400 py-4">
            Your password has successfully been updated.
            <br />
            Please proceed to login to the system with your new details.
          </div>
          <div class="flex w-full items-center justify-center pt-4" v-if="!loading">
            <router-link class="w-full" :to="{ name: 'Login' }">
              <button class="bg-hireful text-white w-full hireful-font-semibold h-12 rounded-lg">
                Proceed to login
              </button>
            </router-link>
          </div>
        </div>
        <div v-else>
          <div class="flex flex-wrap w-full items-center justify-start text-left py-4">
            <div class="flex w-full text-gray-400 hireful-font-domus">
              Please check your email account for the password reset code we have sent and enter it in the field below.
            </div>
            <div class="flex w-full text-gray-400 hireful-font-domus py-2">
              If you do not receive a code and you are certain you have an account please get in touch with <a class="contents text-hireful-link" href="mailto:support@hireful.co.uk">support@hireful.co.uk</a>
            </div>
            <div class="flex flex-wrap w-full items-center justify-start py-4">
              <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
                Reset code
              </div>
              <div class="flex w-full">
                <text-field v-model="resetCode" autocomplete="new-password" @enter="resetPassword()" />
              </div>
            </div>
            <div class="flex w-full text-gray-400 hireful-font-domus py-4">
              Your password must contain at least 8 or more characters and contain a mixture of uppercase, lowercase, symbol and number characters.
            </div>
            <div class="flex flex-wrap w-full items-center justify-center">
              <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
                New password
              </div>
              <div class="flex w-full relative">
                <text-field :type="passwordFieldType" v-model="newPassword" autocomplete="new-password" @enter="resetPassword()" />
              </div>
            </div>
            <div class="flex flex-wrap w-full items-center justify-center py-4">
              <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
                Confirm new password
              </div>
              <div class="flex w-full relative">
                <text-field :type="passwordFieldType" v-model="confirmPassword" autocomplete="new-password" @enter="resetPassword()" />
                <div class="flex items-end justify-end cursor-pointer" @click="switchVisibility()" >
                  <img src="@/assets/icons/eye.svg"
                  class="absolute cursor-pointer h-6 w-6 right-4 top-2 fill-current" v-if="passwordFieldType === 'password'">
                  <img src="@/assets/icons/hide-eye.svg"
                class="absolute cursor-pointer h-6 w-6 right-4 top-2" v-else>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap w-full item-center justify-center" v-if="showNotification">
              <hireful-notification :msg="notificationMessage"></hireful-notification>
            </div>
            <div class="flex w-full items-center justify-center py-4">
              <loader v-if="loading" />
              <div class="flex flex-wrap w-full items-center justify-center" v-else>
                <button class="bg-hireful text-white w-full hireful-font-semibold h-12 rounded-lg" @click="resetPassword()" >
                  Update password
                </button>
                <router-link class="flex w-full items-center justify-center py-4" :to="{ name: 'Login' }">
                  <span class="hireful-font-semibold text-gray-400">
                    Go back
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap w-full items-center justify-center" v-if="false"> <!-- v-else -->
          <div class="flex flex-wrap w-full items-center justify-center text-black text-xs">
            <div class="flex flex-wrap w-full items-center justify-center text-black text-xs">
             Please check your email account for the password reset code we have sent and enter it in the field below.
            </div>
            <div class="flex flex-wrap w-full items-center justify-center text-black text-xs py-2">
            The password you provide must be 8 or more characters long containing a mixture of uppercase, lowercase, symbol and number characters.
            </div>
            <div class="flex flex-wrap w-full items-center justify-center text-black text-xs py-2">
            If you do not receive a code and you are certain you have an account please get in touch with support@hireful.co.uk
            </div>
            <div class="flex flex-wrap w-full items-center justify-center text-black text-xs py-2 font-bold">
              Please note: If you are a new user and have not logged into the system for the first time, you will not receive a reset code.
            </div>
            <div class="flex flex-wrap w-full items-center justify-center text-black text-xs font-bold">
              Instead we will resend your welcome email with your temporary password details. Please follow the steps in that email and ignore this page.
            </div>
          </div>
            <div class="flex flex-wrap w-full items-center justify-center py-4">
              <div class="flex flex-wrap w-1/2 items-center justify-center">
                <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
                  Reset code
                </div>
                <div class="flex w-full">
                  <input type="text" name="resetCode" class="w-full border rounded-md p-2 appearance-none focus:outline-none bg-transparent" v-model="resetCode" autofocus @keyup.enter="resetPassword()" />
                </div>
              </div>
            </div>
            <div class="flex flex-wrap w-full items-center justify-center">
              <div class="flex flex-wrap w-1/2 items-center justify-center">
                <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
                  New password
                </div>
                <div class="flex w-full">
                  <input :type="passwordFieldType" name="newPassword" class="w-full border rounded-md p-2 appearance-none focus:outline-none bg-transparent" autocomplete="new-password" v-model="newPassword" autofocus @keyup.enter="resetPassword()" />
                </div>
              </div>
            </div>
            <div class="flex flex-wrap w-full items-center justify-center">
              <div class="flex flex-wrap w-1/2 items-center justify-center">
                <div class="flex w-full text-gray-400 text-sm py-2 hireful-font-domus">
                  Confirm new password
                </div>
                <div class="flex w-full relative">
                  <input :type="passwordFieldType" name="confirmPassword" class="w-full border rounded-md p-2 appearance-none focus:outline-none bg-transparent" autocomplete="new-password" v-model="confirmPassword" autofocus @keyup.enter="resetPassword()" />

                  <div class="flex items-end justify-end cursor-pointer absolute viewIcon right-4 -top-2" @click="switchVisibility()">
                    <img src="@/assets/icons/eye.svg"
                    class="cursor-pointer h-10 w-10" v-if="passwordFieldType === 'password'">
                    <img src="@/assets/icons/hide-eye.svg"
                      class="cursor-pointer h-10 w-10" v-else>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap w-full item-center justify-center mt-5" v-if="showNotification">
              <hireful-notification :msg="notificationMessage"></hireful-notification>
            </div>
            <div class="flex flex-wrap w-full items-center justify-center mt-7">
              <div class="flex w-full items-center justify-center">
                <loader v-if="loading" />
                  <div v-else>
                    <router-link class="" :to="{ name: 'Login' }">
                      <button class="px-4 text-hireful font-bold h-8 rounded-full text-sm bg-transparent border border-solid border-hireful border-2 w-40">
                        back to login
                      </button>
                    </router-link>
                    <button
                      class="bg-hireful text-white px-4 h-8 font-bold rounded-full ml-8 text-sm w-40"
                      @click="resetPassword()"
                    >update password</button>
                  </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  CognitoUser,
  CognitoUserPool
} from 'amazon-cognito-identity-js'

import axios from 'axios'
import store from '@/store'
import loader from '@/components/loader'
import rules from '@/helpers/validationRules'
import hirefulNotification from '@/components/hireful-notification'
import textField from '@/components/textField'

export default {
  name: 'forgotPassword',
  components: {
    loader,
    hirefulNotification,
    textField
  },
  data () {
    return {
      user: {
        email: this.$route.query.email || ''
      },
      showNotification: false,
      notificationMessage: '',
      loading: false,
      showReset: false,
      resetCode: null,
      newPassword: null,
      confirmPassword: null,
      forgotPasswordContext: null,
      resetSuccess: false,
      pageTitle: 'Forgotten your password?',
      passwordFieldType: 'password'
    }
  },
  mounted () {
    if (this.user.email) {
      this.forgotPassword()
    }
  },
  methods: {
    async forgotPassword () {
      const vm = this
      if (rules.email(vm.user.email)) {
        vm.showNotification = false
        vm.notificationMessage = ''
        vm.loading = true
        const payload = {
          email: vm.user.email
        }
        try {
          await axios.post(`${process.env.VUE_APP_LOGIN_API_HOST}${store.state.routes.checkUserStatus}`, payload)
          vm.processForgotPassword()
        } catch {
          vm.processForgotPassword()
        }
      } else {
        vm.showNotification = true
        vm.notificationMessage = 'Please enter a valid email address'
      }
    },
    processForgotPassword () {
      const vm = this
      const poolData = {
        UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
        ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID
      }
      const userPool = new CognitoUserPool(poolData)
      // setup cognitoUser first
      const cognitoUser = new CognitoUser({
        Username: vm.user.email,
        Pool: userPool
      })

      // call forgotPassword on cognitoUser
      cognitoUser.forgotPassword({
        onSuccess: function (result) {
          vm.showNotification = false
          vm.notificationMessage = ''
          vm.pageTitle = 'Your password has been updated'
          vm.resetSuccess = true
        },
        onFailure: function (err) {
          vm.showNotification = true
          vm.notificationMessage = err.message
        },
        inputVerificationCode () {
          vm.loading = false
          vm.showReset = true
          vm.pageTitle = 'Please provide a new password'
          vm.forgotPasswordContext = this
          // vm.showNotification = true
          // vm.notificationMessage = 'Please check your mail for reset code'
        }
      })
    },
    resetPassword () {
      const vm = this
      if (vm.resetCode) {
        if (!vm.newPassword) {
          vm.showNotification = true
          vm.notificationMessage = 'Please provide the new password'
        } else if (!vm.confirmPassword) {
          vm.showNotification = true
          vm.notificationMessage = 'Please confirm your new password'
        } else if (vm.newPassword === vm.confirmPassword) {
          const poolData = {
            UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
            ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID
          }
          const userPool = new CognitoUserPool(poolData)

          // setup cognitoUser first
          const cognitoUser = new CognitoUser({
            Username: vm.user.email,
            Pool: userPool
          })
          if (vm.forgotPasswordContext.userAttributes && vm.forgotPasswordContext.userAttributes.phone_number_verified) {
            delete vm.forgotPasswordContext.userAttributes.phone_number_verified
          }
          if (vm.forgotPasswordContext['userAttributes.phone_number_verified']) {
            delete vm.forgotPasswordContext['userAttributes.phone_number_verified']
          }
          cognitoUser.confirmPassword(vm.resetCode, vm.newPassword, vm.forgotPasswordContext)
        } else {
          vm.showNotification = true
          vm.notificationMessage = 'Please make sure your passwords match'
        }
      } else {
        vm.showNotification = true
        vm.notificationMessage = 'Please provide the reset code'
      }
    },
    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    }
  }
}
</script>

<style>

</style>
